import { DEFAULT_BOOKING_END, DEFAULT_BOOKING_START, teams } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'

export { DEFAULT_BOOKING_END, DEFAULT_BOOKING_START }

export const selectTeamSchema = createSelectSchema(teams)

// Mantine's TimeInput hands back '' when cleared, and the column means "no
// team window" rather than midnight, so empty lands as NULL. The regex is the
// one guard kept: the booking search reads the value straight into a
// timestamp, so a non-time string would throw in the customer's widget rather
// than here.
const bookingTime = z
  .string()
  .regex(/^(([01]\d|2[0-3]):[0-5]\d)?$/, 'Anna aika muodossa HH:MM')
  .nullable()
  .optional()
  .transform((value) => value || null)

export const insertTeamSchema = createInsertSchema(teams, {
  bookingStartTime: bookingTime,
  bookingEndTime: bookingTime,
}).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export const updateTeamSchema = insertTeamSchema.partial()

export const selectTeamWithLeaderSchema = selectTeamSchema.extend({
  leader: z
    .object({
      id: z.number(),
      user: z
        .object({
          id: z.number(),
          firstName: z.string(),
          lastName: z.string(),
          phoneNumber: z.string().nullable(),
        })
        .optional()
        .nullable(),
    })
    .optional()
    .nullable(),
})

export type Team = z.infer<typeof selectTeamSchema>
export type TeamWithLeader = z.infer<typeof selectTeamWithLeaderSchema>
export type CreateTeam = z.infer<typeof insertTeamSchema>
export type UpdateTeam = z.infer<typeof updateTeamSchema>
